const themes = {
	clearDay: {
		primary: "#3499bd",
		primaryDark: "#194e63",
		primaryLight: "#dceef2",
		secondary: "#e6d8c1",
		secondaryDark: "#e2a870",
		text: "#04111f",
	},
	clearNight: {
		primary: "#1e354e",
		primaryDark: "#04111f",
		primaryLight: "#b6c9d7",
		secondary: "#405963",
		secondaryDark: "#1c292e",
		text: "#04111f",
	},
	cloudy: {
		primary: "#808c96",
		primaryDark: "#325258",
		primaryLight: "#d3e2e4",
		secondary: "#becccd",
		text: "#181818",
		textLight: "#edf6ff",
	},
	hazy: {
		primary: "#a0b1a3",
		primaryDark: "#48584e",
		primaryLight: "#e0f6e6",
		secondary: "#c6dfda",
		secondaryDark: "#7d938e",
		text: "#272d28",
	},
	rainy: {
		primary: "#64888e",
		primaryDark: "#26545d",
		primaryLight: "#dceef2",
		secondary: "#b5c6d6",
		text: "#04111f",
	},
	stormy: {
		primary: "#615c75",
		primaryDark: "#323039",
		primaryLight: "#d0cedb",
		secondary: "#88919a",
		secondaryDark: "#4d545b",
		text: "#120f18",
		textLight: "#edf6ff",
	},
	snowy: {
		primary: "#a8b5cd",
		primaryDark: "#5b6579",
		primaryLight: "#f2f9ff",
		secondary: "#d7d8db",
		text: "#31334e",
	},
};

export default themes;
